<footer class="site-footer">
  <div class="footer-body">
    <div class="container">
      <div class="row">

        <!-- Brand column -->
        <div class="col-12 col-md-4 footer-col footer-brand">
          <a routerLink="/products" class="footer-logo">
            <span class="logo-text">Prop<span class="logo-accent">Desk</span></span>
          </a>
          <p class="footer-tagline">
            Your hub for prop firm comparisons, NinjaTrader tools, and trading downloads.
          </p>
          <a href="mailto:support@propdesk360.com" class="footer-email">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            support@propdesk360.com
          </a>

          <div class="footer-socials">
            <a href="https://discord.gg/yUEdgNe27" target="_blank" rel="noopener noreferrer" class="footer-social-btn footer-social-btn--discord" aria-label="Join PropDesk on Discord">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.522 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/>
              </svg>
              Discord
            </a>
            <a href="https://www.youtube.com/@propdesk360" target="_blank" rel="noopener noreferrer" class="footer-social-btn footer-social-btn--youtube" aria-label="Subscribe to PropDesk on YouTube">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              YouTube
            </a>
            <a href="https://x.com/PropDesk360" target="_blank" rel="noopener noreferrer" class="footer-social-btn footer-social-btn--twitter" aria-label="Follow PropDesk on X">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.91-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              X / Twitter
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="col-6 col-md-2 footer-col">
          <h3 class="footer-col-title">PropDesk</h3>
          <ul class="footer-links">
            <li><a routerLink="/about">About Us</a></li>
            <li><a routerLink="/propdesk">Prop Firms</a></li>
            <li><a routerLink="/overview">Overview</a></li>
            <li><a routerLink="/ninja">NinjaTrader</a></li>
            <li><a routerLink="/products">Products</a></li>
            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
            <li><a routerLink="/contact-us">Contact Us</a></li>
          </ul>
        </div>

        <!-- Tools -->
        <div class="col-6 col-md-3 footer-col">
          <h3 class="footer-col-title">Tools</h3>
          <ul class="footer-links">
            <li><a routerLink="/consistency-calculator">Consistency Calculator</a></li>
            <li><a routerLink="/tick-value-calculator">Tick Value Calculator</a></li>
            <li><a routerLink="/position-size-calculator">Position Size Calculator</a></li>
            <li><a routerLink="/session-times">Session Times</a></li>
            <li><a routerLink="/holiday-trading-hours">Holiday Trading Hours</a></li>
            <li><a href="https://www.forexfactory.com/calendar" target="_blank" rel="noopener noreferrer">Forex Factory Calendar</a></li>
          </ul>
        </div>

        <!-- Disclaimer -->
        <div class="col-12 col-md-3 footer-col">
          <h3 class="footer-col-title">Disclaimer</h3>
          <p class="footer-disclaimer-text">
            For educational &amp; entertainment purposes only. Not financial or trading advice.
            Trading involves substantial risk of loss. Past performance does not guarantee future results.
            Not a registered investment advisor. All participation is voluntary and at your own risk.
          </p>
          <a routerLink="/risk-disclosure" class="footer-disclaimer-link">Read full disclaimer</a>
        </div>

      </div>
    </div>
  </div>

  <div class="footer-bar">
    <div class="container">
      <p>&copy; 2023 PropDesk. All rights reserved.</p>
    </div>
  </div>
</footer>
